﻿'use strict';

angular.module('ntmApp').factory('RoomSchedules', ['RoomSchedulesFilter', 'ForecastService', 'FlashService', 'Constants', 'UnderAllocatedStaff', 'Utils', 'ForecastingFiltersProvider',
function (RoomSchedulesFilter, ForecastService, FlashService, Constants, UnderAllocatedStaff, Utils, ForecastingFiltersProvider) {

    function RoomSchedules(ForecastContext) {

        var self = this;
        var context = ForecastContext;

        self.UnderAllocatedStaff = new UnderAllocatedStaff(context.forecastMode);
        self.Filter = new RoomSchedulesFilter();

        self.showFilter = false;

        self.filterSettings = {
            displayProp: 'value',
            attachDisplayProp: true,
            smartButtonMaxItems: 5,
            scrollableHeight: '200px',
            enableSearch: true
        };

        self.forecastMode = context.forecastMode;

        self.selectedActivityType = Constants.ForecastActivityTypes.RoomActivities;
        self.activityTypes = [
            Constants.ForecastActivityTypes.RoomActivities,
            Constants.ForecastActivityTypes.OtherActivities
        ];

        self.filterDataSource = {};

        self.loadForecastRoomHeaders = function (header, selectedWeek) {

            var request = context.prepareDataForRequest();

            request.forecastView = header.forecastOptionsSummary.forecastView;
            request.forecastScope = header.selectedForecastScope.id.trim();
            request.dateFrom = selectedWeek.startDate;
            request.dateTo = selectedWeek.endDate;

            self.forecastView = header.forecastOptionsSummary.forecastView;

            self.dataLoading = true;

            ForecastService.GetRoomScheduleHeader(request).then(function (result) {

                self.roomBlockHeaders = result.data.roomScheduleHeaders;
                self.roomItems = getRoomItems(self.roomBlockHeaders);

                applyAssignedStaffDataSource();

                if (self.roomBlockHeaders) {
                    self.roomBlockHeaders.forEach(function (block) {

                        if (block.dowActivityToggles) {
                            block.dowActivityToggles.forEach(function (dow) {
                                dow.dndTarget = [];
                                dow.blockHeader = {
                                    roomNumber: block.roomNumber,
                                    facilityCode: block.facilityCode,
                                    areaId: block.areaId
                                };
                            });
                        }

                        block.dowActivityToggles = fillCorrespondingDOW(getDOWContainer(selectedWeek), block.dowActivityToggles);
                    });
                }
                if (!self.soringAttributes.sortBy.sortKey) {
                    self.sortBy(self.soringAttributes.byRoomNumber.key);
                }

                ForecastingFiltersProvider.LoadFilters().then(function (filters) {
                    if (filters) {
                        self.filterDataSource.roomTypeItems = filters.roomTypeFilters;
                        Utils.AddBlankOption(self.filterDataSource.roomTypeItems);
                        self.dataLoading = false;
                    }
                });

            });
        };


        self.loadOtherActivitiesHeaders = function (header, selectedWeek) {

            var request = context.prepareDataForRequest();

            request.forecastView = header.forecastOptionsSummary.forecastView;
            request.forecastScope = header.selectedForecastScope.id.trim();
            request.dateFrom = selectedWeek.startDate;
            request.dateTo = selectedWeek.endDate;

            self.dataLoading = true;

            ForecastService.GetOtherActivitiesHeaders(request).then(function (result) {

                if (result.data.otherActivitiesHeaders) {
                    self.otherActivitiesHeaders = { area: {}, facility: {} };
                    self.otherActivitiesHeaders.area.dowActivityToggles = result.data.otherActivitiesHeaders.areaActivities;
                    self.otherActivitiesHeaders.facility.dowActivityToggles = result.data.otherActivitiesHeaders.facilityActivities;

                    if (self.otherActivitiesHeaders.area.dowActivityToggles && self.otherActivitiesHeaders.area.dowActivityToggles.length > 0) {

                        self.otherActivitiesHeaders.area.dowActivityToggles.forEach(function (dowActivityToggles) {
                            dowActivityToggles.dndTarget = [];
                            dowActivityToggles.blockHeader = {
                                otherActivityMode: 'Area',
                                facilityCode: dowActivityToggles.groupID
                            };
                        });

                        self.otherActivitiesHeaders.area.dowActivityToggles = fillCorrespondingDOW(getDOWContainer(selectedWeek), self.otherActivitiesHeaders.area.dowActivityToggles);
                    }

                    if (self.otherActivitiesHeaders.facility.dowActivityToggles && self.otherActivitiesHeaders.facility.dowActivityToggles.length > 0) {

                        self.otherActivitiesHeaders.facility.dowActivityToggles.forEach(function (dowActivityToggles) {
                            dowActivityToggles.dndTarget = [];
                            dowActivityToggles.blockHeader = {
                                otherActivityMode: 'Facility',
                                areaId: dowActivityToggles.groupID
                            };
                        });

                        self.otherActivitiesHeaders.facility.dowActivityToggles = fillCorrespondingDOW(getDOWContainer(selectedWeek), self.otherActivitiesHeaders.facility.dowActivityToggles);
                    }
                }
               
                self.dataLoading = false;
            });
        };

        function getDOWContainer(selectedWeek) {
            var DOWContainerArray = [];

            var day = selectedWeek.startDate;

            for (var i = 0; i <= selectedWeek.endDate.diff(selectedWeek.startDate, 'days') ; i++) {
                DOWContainerArray.push(day);

                day = day.clone().add(1, 'd');
            }

            return DOWContainerArray;
        }

        function fillCorrespondingDOW(dowContainer, dowHours) {

            for (var i = 0; i < dowContainer.length; i++) {
                for (var j = 0; j < dowHours.length; j++) {
                    if (moment(dowContainer[i]).isSame(moment(dowHours[j].date), 'day')) {
                        dowContainer[i] = dowHours[j];

                        break;
                    }
                }
            }

            return dowContainer;
        }

        self.reloadRoomBlockHeader = function (header, blockHeader, selectedWeek) {

            var request = context.prepareDataForRequest();

            request.roomNumberFilter = blockHeader.roomNumber;
            request.dateFrom = selectedWeek.startDate;
            request.dateTo = selectedWeek.endDate;
            request.forecastView = header.forecastOptionsSummary.forecastView;
            request.forecastScope = header.selectedForecastScope.id.trim();

            var loading = FlashService.Loading();
            ForecastService.GetRoomScheduleHeader(request).then(function (result) {

                loading.dismiss();

                if (result.success) {

                    var updatedBlockHeader = result.data.roomScheduleHeaders[0];

                    var activeDOW = blockHeader.dowActivityToggles.firstOrDefault(function (dow) {
                        return dow.active;
                    });


                    blockHeader.dowActivityToggles = updatedBlockHeader.dowActivityToggles;
                    applyAssignedStaffDataSource();

                    blockHeader.dowActivityToggles.forEach(function (dow) {

                        dow.dndTarget = [];
                        dow.blockHeader = {
                            roomNumber: blockHeader.roomNumber,
                            facilityCode: blockHeader.facilityCode
                        };

                        if (activeDOW) {

                            var currentDOWDate = moment(dow.date);
                            var activeDOWDate = moment(activeDOW.date);

                            if (currentDOWDate.isSame(activeDOWDate)) {
                                dow.active = true;
                                loadDOWActivities(header, blockHeader, selectedWeek, currentDOWDate);
                            }
                        }

                    });

                    blockHeader.dowActivityToggles = fillCorrespondingDOW(getDOWContainer(selectedWeek), blockHeader.dowActivityToggles);
                }
            });
        };

        self.reloadOtherActivities = function (header, selectedWeek) {

            var request = context.prepareDataForRequest();

            request.forecastView = header.forecastOptionsSummary.forecastView;
            request.forecastScope = header.selectedForecastScope.id.trim();
            request.dateFrom = selectedWeek.startDate;
            request.dateTo = selectedWeek.endDate;

            var loading = FlashService.Loading();

            var previousHeaders = angular.copy(self.otherActivitiesHeaders);

            ForecastService.GetOtherActivitiesHeaders(request).then(function (result) {

                if (result.data.otherActivitiesHeaders) {
                    self.otherActivitiesHeaders = { area: {}, facility: {} };
                    self.otherActivitiesHeaders.area.dowActivityToggles = result.data.otherActivitiesHeaders.areaActivities;
                    self.otherActivitiesHeaders.facility.dowActivityToggles = result.data.otherActivitiesHeaders.facilityActivities;

                    if (self.otherActivitiesHeaders.area.dowActivityToggles && self.otherActivitiesHeaders.area.dowActivityToggles.length > 0) {

                        self.otherActivitiesHeaders.area.dowActivityToggles.forEach(function (dowActivityToggles) {
                            dowActivityToggles.dndTarget = [];
                            dowActivityToggles.blockHeader = {
                                otherActivityMode: 'Area',
                                facilityCode: dowActivityToggles.groupID
                            };
                        });

                        self.otherActivitiesHeaders.area.dowActivityToggles = fillCorrespondingDOW(getDOWContainer(selectedWeek), self.otherActivitiesHeaders.area.dowActivityToggles);
                    }

                    if (self.otherActivitiesHeaders.facility.dowActivityToggles && self.otherActivitiesHeaders.facility.dowActivityToggles.length > 0) {

                        self.otherActivitiesHeaders.facility.dowActivityToggles.forEach(function (dowActivityToggles) {
                            dowActivityToggles.dndTarget = [];
                            dowActivityToggles.blockHeader = {
                                otherActivityMode: 'Facility',
                                areaId: dowActivityToggles.groupID
                            };
                        });

                        self.otherActivitiesHeaders.facility.dowActivityToggles = fillCorrespondingDOW(getDOWContainer(selectedWeek), self.otherActivitiesHeaders.facility.dowActivityToggles);
                    }

                    loading.dismiss();

                    if (previousHeaders && previousHeaders.facility) {

                        var activeFacilityDOW = previousHeaders.facility.dowActivityToggles.firstOrDefault(function (dow) {
                            return dow.active;
                        });

                        if (activeFacilityDOW) {

                            var currentActiveFacilityDOW = self.otherActivitiesHeaders.facility.dowActivityToggles.firstOrDefault(function (dow) {
                                return moment(dow.date).isSame(moment(activeFacilityDOW.date), 'days');
                            });

                            if (currentActiveFacilityDOW) {
                                currentActiveFacilityDOW.active = true;
                                loadOtherDOWActivities(header, self.otherActivitiesHeaders.facility, selectedWeek, currentActiveFacilityDOW, 1);
                            }
                            
                        }
                    }

                    if (previousHeaders && previousHeaders.area) {

                        var activeAreaDOW = previousHeaders.area.dowActivityToggles.firstOrDefault(function (dow) {
                            return dow.active;
                        });

                        if (activeAreaDOW) {

                            var currentActiveAreaDOW = self.otherActivitiesHeaders.area.dowActivityToggles.firstOrDefault(function (dow) {
                                return moment(dow.date).isSame(moment(activeAreaDOW.date), 'days');
                            });

                            if (currentActiveAreaDOW) {
                                currentActiveAreaDOW.active = true;
                                loadOtherDOWActivities(header, self.otherActivitiesHeaders.area, selectedWeek, currentActiveAreaDOW, 0);
                            }

                        }
                    }

                }
            });
        };

        function applyAssignedStaffDataSource() {

            var result = [];

            self.roomBlockHeaders.forEach(function (block) {

                block.dowActivityToggles.forEach(function (dow) {

                    if (dow.alertRoomAssignmentTotals) {
                        dow.alertRoomAssignmentTotals.forEach(function (assigmentItem) {

                            result.push({
                                id: assigmentItem.personId,
                                value: assigmentItem.personName
                            });

                        });
                    }
                });
            });

            self.filterDataSource.assignedStaffItems = result.unique(function (item1, item2) {
                return item1.id === item2.id;
            });

            onAssignedStaffFilterDataSourceChanged();
        }

        self.getBlockByRoomNumber = function (roomNumber) {

            if (self.roomBlockHeaders) {
                return self.roomBlockHeaders.firstOrDefault(function (block) {
                    return block.roomNumber === roomNumber;
                });
            }

            return null;
        };

        self.selectActivitiesOfDay = function (header, dowHours, blockHeader, selectedWeek) {

            blockHeader.dowActivityToggles.forEach(function (dow) {

                if (dow !== dowHours) {
                    dow.active = false;
                }
            });

            dowHours.active = !dowHours.active;

            if (dowHours.active) {
                var dowDate = moment(dowHours.date);

                loadDOWActivities(header, blockHeader, selectedWeek, dowDate);

            } else {
                blockHeader.currentGrid = null;
            }
        };

        self.selectOtherActivitiesOfDay = function (header, dowHours, blockHeader, selectedWeek, type) {

            blockHeader.dowActivityToggles.forEach(function (dow) {

                if (dow !== dowHours) {
                    dow.active = false;
                }
            });

            dowHours.active = !dowHours.active;

            if (dowHours.active) {
                loadOtherDOWActivities(header, blockHeader, selectedWeek, dowHours, type);

            } else {
                blockHeader.currentGrid = null;
            }
        };

        function loadDOWActivities(header, blockHeader, selectedWeek, dateToSelect) {

            var request = context.prepareDataForRequest();

            request.facilityCode = blockHeader.facilityCode;
            request.roomNumber = blockHeader.roomNumber;
            request.date = dateToSelect;
            request.forecastView = header.forecastOptionsSummary.forecastView;
            request.forecastScope = header.selectedForecastScope.id.trim();

            blockHeader.activitiesAreLoading = true;

            ForecastService.GetRoomDOWActivities(request).then(function (result) {

                blockHeader.activitiesAreLoading = false;

                if (result.success) {
                    blockHeader.DOWActivitiesGrids = groupDOWActivitiesByDaysOfWeek(blockHeader, result.data);

                    if (dateToSelect) {
                        blockHeader.currentGrid = syncGridUIState(blockHeader.currentGrid, blockHeader.DOWActivitiesGrids.firstOrDefault(function (grid) {
                            return grid.date.isSame(dateToSelect);
                        }));
                    }
                }
            });
        }

        function loadOtherDOWActivities(header, blockHeader, selectedWeek, dowHours, type) {

            var request = context.prepareDataForRequest();

            request.facilityCode = blockHeader.facilityCode;
            request.date = moment(dowHours.date);
            request.forecastView = header.forecastOptionsSummary.forecastView;
            request.forecastScope = header.selectedForecastScope.id.trim();
            request.otherActivityType = type;

            var group = type === 1 ? self.otherActivitiesHeaders.facility : self.otherActivitiesHeaders.area;

            blockHeader.activitiesAreLoading = true;

            ForecastService.GetOtherDOWActivities(request).then(function (result) {

                group.activitiesAreLoading = false;

                if (result.success) {
                    group.currentGrid = prepareOtherDOWActivitiesData(dowHours, result.data);
                }
            });
        }

        function prepareOtherDOWActivitiesData(dowHours, activities) {
            var dowActivitiesGrid = {};

            var groups = activities.groupBy('facilityAreaGroup').map(function (group) {
                var ids = [];

                group.dndTarget = [];
                group.dndType = [];
                group.assignedStaff = [];
                group.date = moment(dowHours.date);
                group.expanded = true;
                group.otherActivityMode = dowHours.blockHeader.otherActivityMode;

                group.items.forEach(function (activity) {
                    group.groupID = activity.areaGroupID || activity.facilityGroupID;
                    activity.dndTarget = [];
                    activity.dndType = [];
                    if (activity.assigneeId) {
                        if (ids.indexOf(activity.assigneeId) === -1) {
                            ids.push(activity.assigneeId);

                            group.assignedStaff.push({
                                personId: activity.assigneeId,
                                personName: activity.assignee,
                                date: activity.dateSchedule,
                                duration: activity.duration,
                                schedules: [activity.scheduleId]
                            });
                        } else {
                            group.assignedStaff.map(function (staff) {
                                if (staff.personId === activity.assigneeId) {
                                    staff.duration += activity.duration;
                                    staff.schedules.push(activity.scheduleId);
                                }
                            });
                        }
                    }
                });

                group.icons = context.getUniqueIcons(group.items);

                group.blockHeader = {};

                if (group.otherActivityMode === 'Area') {
                    group.blockHeader.areaId = group.groupID;
                } else {
                    group.blockHeader.facilityCode = group.groupID;
                }

                group.assignedStaffLimit = group.assignedStaff.length <= 3 ? group.assignedStaff.length : 2;
                group.cssClasses = group.assignedStaff.length === 1 ? 'col-md-12 col-xs-12' :
                    group.assignedStaff.length === 2 ? 'col-md-6 col-xs-6' : 'col-md-4 col-xs-4';

                return group;
            }).sort(function (group1, group2) {
                return group1.key.localeCompare(group2.key);
            });

            dowActivitiesGrid = {
                groups: groups,
                summary: dowHours
            };

            return dowActivitiesGrid;
        }

        function groupDOWActivitiesByDaysOfWeek(blockHeader, activities) {

            var dowActivitiesGrids = [];

            blockHeader.dowActivityToggles.forEach(function (dow) {
                var activitiesOfDay = activities.filter(function (activity) {
                    var activityDate = moment(activity.dateSchedule);
                    var dowDate = moment(dow.date);
                    return activityDate.diff(dowDate, 'days') === 0;
                }).map(function (activity) {
                    activity.roomNumber = blockHeader.roomNumber;
                    return activity;
                });

                var groupByLocate = activitiesOfDay.groupBy('locate').map(function (group) {
                    var ids = [];

                    group.dndTarget = [];
                    group.dndType = [];
                    group.assignedStaff = [];
                    group.date = moment(dow.date);
                    group.blockHeader = blockHeader;
                    group.roomNumber = blockHeader.roomNumber;
                    group.facilityCode = blockHeader.facilityCode;

                    group.items.forEach(function (activity) {
                        activity.dndTarget = [];
                        activity.blockHeader = blockHeader;
                        activity.dndType = [];
                        if (activity.assigneeId) {
                            if (ids.indexOf(activity.assigneeId) === -1) {
                                ids.push(activity.assigneeId);

                                group.assignedStaff.push({
                                    personId: activity.assigneeId,
                                    personName: activity.assignee,
                                    locate: group.key,
                                    roomNumber: group.roomNumber,
                                    date: activity.dateSchedule,
                                    duration: activity.duration,
                                    schedules: [activity.scheduleId]
                                });
                            } else {
                                group.assignedStaff.map(function (staff) {
                                    if (staff.personId === activity.assigneeId) {
                                        staff.duration += activity.duration;
                                        staff.schedules.push(activity.scheduleId);
                                    }
                                });
                            }
                        }
                    });

                    group.icons = context.getUniqueIcons(group.items);

                    group.assignedStaffLimit = group.assignedStaff.length <= 3 ? group.assignedStaff.length : 2;
                    group.cssClasses = group.assignedStaff.length === 1 ? 'col-md-12 col-xs-12' :
                        group.assignedStaff.length === 2 ? 'col-md-6 col-xs-6' : 'col-md-4 col-xs-4';

                    return group;
                }).sort(function (group1, group2) {
                    return group1.key.localeCompare(group2.key);
                });

                var dowDate = moment(dow.date);

                dowActivitiesGrids.push({
                    groups: groupByLocate,
                    roomNumber: blockHeader.roomNumber,
                    dayOfWeek: dowDate.day(),
                    date: dowDate,
                    summary: dow
                });
            });

            return dowActivitiesGrids;
        }

        self.expandAllActivities = function (grid) {
            setExpandedState(grid, true);
        };

        self.collapseAllActivities = function (grid) {
            setExpandedState(grid, false);
        };

        function setExpandedState(grid, state) {
            grid.groups.forEach(function (group) {
                group.expanded = state;
            });
        }

        self.collapseAllBlockHeaders = function () {

            if (self.roomBlockHeaders) {
                self.roomBlockHeaders.forEach(function (block) {
                    block.dowActivityToggles.forEach(function (dow) {
                        dow.active = false;
                    });
                    block.currentGrid = null;
                });
            }
        };

        self.collapseOtherActivitiesBlockHeaders = function () {

            if (self.otherActivitiesHeaders.facility) {
                self.otherActivitiesHeaders.facility.dowActivityToggles.forEach(function (dow) {
                    dow.active = false;
                });
                self.otherActivitiesHeaders.facility.currentGrid = null;
            }

            if (self.otherActivitiesHeaders.area) {
                self.otherActivitiesHeaders.area.dowActivityToggles.forEach(function (dow) {
                    dow.active = false;
                });
                self.otherActivitiesHeaders.area.currentGrid = null;
            }
        };

        self.toggleFilter = function () {
            self.showFilter = !self.showFilter;
        };

        self.togglePinState = function (blockHeader) {
            blockHeader.pinned = !blockHeader.pinned;
        };

        self.displayDOWLabel = function (dow, hasNoActivity) {
            return !hasNoActivity ? "{0}: {1}/{2}".format(Constants.DayLabels.getLabel(moment(dow.date)), dow.assignedActivityCount, dow.allActivityCount)
                   : "{0}: 0/0".format(Constants.DayLabels.getLabel(dow));
        };


        self.SORTING_STATE = {
            NONE: "NONE",
            ASC: "ASC",
            DESC: "DESC"
        };

        self.soringAttributes = {
            byRoomNumber: {
                key: 'roomNumber',
                value: self.SORTING_STATE.NONE
            },

            byRoomStatus: {
                key: 'roomStatusIndicator',
                value: self.SORTING_STATE.NONE
            },

            byRoomType: {
                key: 'roomType',
                value: self.SORTING_STATE.NONE
            },

            sortBy: {
                reverse: false
            },

            apply: function (key) {

                for (var property in this) {
                    if (this.hasOwnProperty(property) && !angular.isFunction(this[property])) {
                        var attr = this[property];

                        if (attr.key === key) {
                            attr.value = attr.value === self.SORTING_STATE.NONE ?
                                self.SORTING_STATE.ASC :
                                attr.value === self.SORTING_STATE.ASC ?
                                               self.SORTING_STATE.DESC :
                                               self.SORTING_STATE.ASC;

                            this.sortBy.sortKey = key;
                            this.sortBy.reverse = attr.value === self.SORTING_STATE.DESC;

                        } else {
                            attr.value = self.SORTING_STATE.NONE;
                        }
                    }
                }
            }
        };

        self.sortBy = function (sortingKey) {
            self.soringAttributes.apply(sortingKey);
        };

        self.clearAllPins = function () {

            if (self.roomBlockHeaders) {
                self.roomBlockHeaders.forEach(function (block) {
                    block.pinned = false;
                });
            }

            self.showOnlyPinned = false;
        };

        self.loadRightPanes = function (header, selectedWeek) {
            self.UnderAllocatedStaff.load(header, selectedWeek, context.scenarioId);
        };

        self.reload = function (header, selectedWeek) {
            self.loadForecastRoomHeaders(header, selectedWeek);
            self.loadRightPanes(header, selectedWeek);
        };

        self.defaultDragAndDropTargetsForBlockRoomHeaders = function () {

            self.roomBlockHeaders.forEach(function (block) {
                block.dowActivityToggles.forEach(function (dow) {
                    dow.dndTarget = [];
                    dow.dndType = [];
                });

                if (block.DOWActivitiesGrids) {
                    block.DOWActivitiesGrids.forEach(function (grid) {

                        if (grid.groups) {
                            grid.groups.forEach(function (group) {
                                group.dndTarget = [];
                                group.dndType = [];

                                group.items.forEach(function (activity) {
                                    activity.dndTarget = [];
                                    activity.dndType = [];
                                });
                            });
                        }

                    });
                }
            });
        };

        self.defaultDragAndDropTargetsForBlockOtherActivityHeaders = function () {

            self.roomBlockHeaders.forEach(function (block) {
                block.dowActivityToggles.forEach(function (dow) {
                    dow.dndTarget = [];
                    dow.dndType = [];
                });

                if (block.DOWActivitiesGrids) {
                    block.DOWActivitiesGrids.forEach(function (grid) {

                        if (grid.groups) {
                            grid.groups.forEach(function (group) {
                                group.dndTarget = [];
                                group.dndType = [];

                                group.items.forEach(function (activity) {
                                    activity.dndTarget = [];
                                    activity.dndType = [];
                                });
                            });
                        }

                    });
                }
            });
           
            self.otherActivitiesHeaders.area.dowActivityToggles.forEach(function (dow) {
                dow.dndTarget = [];
                dow.dndType = [];
            });

            if (self.otherActivitiesHeaders.area.currentGrid) {
                self.otherActivitiesHeaders.area.currentGrid.groups.forEach(function (group) {
                    group.dndTarget = [];
                    group.dndType = [];

                    group.items.forEach(function (activity) {
                        activity.dndTarget = [];
                        activity.dndType = [];
                    });
                });
            }
          
            self.otherActivitiesHeaders.facility.dowActivityToggles.forEach(function (dow) {
                dow.dndTarget = [];
                dow.dndType = [];
            });

            if (self.otherActivitiesHeaders.facility.currentGrid) {
                self.otherActivitiesHeaders.facility.currentGrid.groups.forEach(function (group) {
                    group.dndTarget = [];
                    group.dndType = [];

                    group.items.forEach(function (activity) {
                        activity.dndTarget = [];
                        activity.dndType = [];
                    });
                });
            }
        };

        self.getStaffAttends = function (data, callback) {
            if (!data.personId) {
                return callback();
            }
            var loading = FlashService.Loading();
            ForecastService.GetStaffAttends(data).then(function (result) {

                loading.dismiss();

                if (result.success) {
                    callback(result.data);
                }
            });
        };

        self.getScenarioId = function () {
            return context.scenarioId;
        };

        function getRoomItems(blockHeaders) {

            if (blockHeaders) {
                return blockHeaders.map(function (block) {
                    return {
                        id: block.roomNumber,
                        value: block.roomNumber
                    };
                }).unique(function (item1, item2) {
                    return item1.id === item2.id;
                });
            }

            return [];
        }

        function onAssignedStaffFilterDataSourceChanged() {

            if (self.Filter.AssignedStaffFilter.filterItem && self.Filter.AssignedStaffFilter.filterItem.id) {

                if (!self.filterDataSource.assignedStaffItems.some(function (item) {
                       return self.Filter.AssignedStaffFilter.filterItem.id === item.id;
                })) {
                    self.Filter.AssignedStaffFilter.clear();
                }
            }
        }

        function syncGridUIState(previousGrid, newGrid) {

            if (previousGrid && newGrid) {

                newGrid.groups.forEach(function (group) {

                    var previousGroup = previousGrid.groups.firstOrDefault(function (prevGroupItem) {
                        return prevGroupItem.groupName === group.groupName;
                    });

                    if (previousGroup) {
                        group.expanded = previousGroup.expanded;
                    }
                });
            }

            return newGrid;
        }

        self.selectRoom = function () {
            self.selectedRoom = self.filterSelectedRoom;
        };     
    }

    return (RoomSchedules);
}]);